module.exports = __webpack_public_path__ + "static/assets/bdddbf3adf228e234ab8e540612658f9.svg";